import React, { useEffect, useCallback, useState} from 'react';
import PlayTick from './PlayTick.js';
import {TrackVisualization}  from 'components/arrangement/getVisualization.js';
import {connect} from 'react-redux';

const PadVisualizer = ({container, pad, selectedTrack, trackToShow, ...props}) => { 
    let length = pad.patternLength;
    let track = pad.tracks.filter(x => x)[0];
    let patternNumber = track && track.currentPattern;
    if (length == -Infinity) {
        length = 32;
    }
    let width = trackToShow ? 700 : 210;
    return (
        <div style={{width}} className="visualizer">
          <PlayTick sequencerEngine={pad.sequencerEngine} length={length} stepWidth={250/length}/>
          {pad.tracks.filter(x => x)
           .map(track =>
                <TrackVisualization
                  key={track.id}
                  steps={props[track.trackNumber]}
                  isSelected={selectedTrack === track.trackNumber}
                  stepWidth={width/length}
                  patternNumber={patternNumber} duration={length} track={track}/>)}
              
        </div>);
}

const mapStateToProps = (state, props) => {
    let s = {
        selectedTrack: state.mix.selectedTrack
    };
    for (let track of props.pad.tracks) {
        if (track) {
            s[track.trackNumber] = state.tracks.trackSteps[track.trackNumber];
        }
    }
    return s;
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PadVisualizer);
